<template>
  <div>
    <div class="card box is-boxed-3" style="margin-bottom: 20px;">
      <header class="card-header">
        <p class="card-header-title">
          Cari perguruan tinggi anda
        </p>
      </header>
      <div class="card-content">
        <university-filter
          :dataProvider="dataProvider"
          :clickHandler="() => { data = {
            university_id: '',
            username: '',
            password: ''
          }; getUniversities(true) }"
          :loading="loading_get_universities_refresh"
          :sortOptions="[]"
          searchCriteria="name,code"
          style="margin-bottom: 10px;"
          :fields="[]"
        ></university-filter>
      </div>
      <hr style="margin: 0;">

      <div class="card-table">
        <div class="content">
          <div class="table-container">
            <table class="table is-fullwidth is-striped">
              <tbody>
                <tr v-if="loading_get_universities_refresh">
                  <td colspan="2"><spinner-loading></spinner-loading></td>
                </tr>
                <tr
                  v-if="!loading_get_universities_refresh && filterable_universities.length != 0"
                  v-for="(university, index) in filterable_universities"
                  :key="index"
                >
                  <!-- <td width="5%"><i class="fa fa-bell-o"></i></td> -->
                  <td>{{ university.name }}</td>
                  <td class="has-text-right">
                    <i v-if="data.university_id == university.id" class="fa fa-check has-text-success"></i>

                    <a v-else href="#" class="button is-small is-info has-pulled-right" @click.prevent="selectUniversity(university.id)">Pilih</a>
                  </td>
                </tr>
                <tr v-else-if="!loading && isEmpty(filterable_universities) && !isEmpty(search) && search.length > 2">
                  <td colspan="2" class="has-text-centered has-text-grey">
                    <p class="help">Perguruan tinggi Anda tidak ditemukan, jangan khawatir, klik tombol dibawah ini.</p>
                    <a href="https://forms.gle/jGwC6TDp3qmGFVdM8" class="button is-primary" target="_blank" rel="noopener" style="margin-bottom: 10px; backgrond-color: transparent; cursor: inherit;">
                      <span>Hubungi Kami</span>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" v-if="!loading_get_universities && !loading_get_universities_refresh">
                    <pagination :dataProvider="dataProvider" :clickHandler="getUniversities"></pagination>
                  </td>
                  <td colspan="2" v-if="loading_get_universities">
                    <spinner-loading></spinner-loading>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <form action="" id="university-form" ref="university_form" v-show="!isEmpty(selected_university) && !isEmpty(selected_university.url)">
      <div class="box is-boxed-3" style="margin-bottom: 20px;">
        <p>Masukkan username & password SIA (Sistem Informasi Akademik) anda dengan benar.</p>
        <br>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Perguruan Tinggi</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input v-if="selected_university !== null"
                  class="input is-medium"
                  type="text"
                  placeholder="Silahkan pilih perguruan tinggi anda"
                  :value="selected_university.name"
                  disabled
                />

                <input v-else
                  class="input is-medium"
                  type="text"
                  placeholder="Silahkan pilih perguruan tinggi anda"
                  disabled
                />

                <span class="icon is-small is-left">
                  <i class="far fa-building"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal" v-if="!isEmpty(selected_university)">
          <div class="field-label is-normal">
            <label class="label">URL</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input v-if="selected_university !== null"
                  class="input is-medium"
                  type="text"
                  placeholder="URL Sistem Informasi Perguruan Tinggi"
                  :value="getHostnameUrl(selected_university.url)"
                  disabled
                />

                <span class="icon is-small is-left">
                  <i class="fas fa-link"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Username</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input class="input is-medium m-input" type="text" ref="username" placeholder="Username" name="username" v-model="data.username" required/>
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Password</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input class="input is-medium m-input" type="password" placeholder="Password" name="password" v-model="data.password" required/>
                <span class="icon is-small is-left">
                  <i class="fa fa-key"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="columns">
      <div class="column has-text-right">
        <button type="button" class="button is-white is-outlined is-medium" @click.prevent="afterSave" v-if="wizard">
          <span>Lewati</span>
          <span class="icon">→</span>
        </button>
      </div>

      <div class="column is-narrow has-text-right">
        <button @click.prevent="addUniversity" type="button" class="button is-primary4 is-medium" :class="loading_connect ? 'is-loading' : ''" :disabled="loading_connect">
          <span>Simpan</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { UNIVERSITY } from '~/consts';

export default {
  props: {
    afterSave: {
      type: Function,
      default: null
    },
    wizard: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.getUniversities(true);
  },

  computed: {
    selected_university() {
      const id = this.data.university_id;

      if (!this.isEmpty(id)) {
        return collect(this.universities).where('id', id).first();
      }

      return null;
    },
    filterable_universities() {
      const search = this.search;
      let universities = this.universities

      // if (!this.isEmpty(search) && search.length > 2) {
        return collect(universities).filter((uni, index) => {
          return uni.name.toLowerCase().includes(search.toLowerCase());
        }).toArray();
      // }

      // return [];
    }
  },

  data() {
    return {
      loading: false,
      loading_connect: false,
      loading_get_universities: false,
      loading_get_universities_refresh: false,
      search: '',
      data: {
        university_id: '',
        username: '',
        password: ''
      },
      universities: [],
      dataProvider: {
        page: {
          current: 1,
        },
        criterion: [{
          criteria: 'name,code',
          operator: 'LK',
          value: ''
        }]
      }
    }
  },

  methods: {
    ...mapActions({
      getMyUniversities: 'universities/getMe',
    }),
    getUniversities(refresh = false) {
      const vm = this

      if (refresh) {
        vm.dataProvider.page['current'] = 1
        vm.loading_get_universities_refresh = true
      } else {
        vm.loading_get_universities = true
      }

      this.$axios.post(UNIVERSITY.GET_PAGINATED, {
        dataProvider: JSON.stringify(vm.dataProvider)
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          let universities = data.data.data;

          if (!refresh) {
            universities = collect(vm.universities).merge(universities).toArray()
          }

          vm.universities = universities
          vm.dataProvider = data.data.dataProvider
        }

        vm.loading_get_universities = false
        vm.loading_get_universities_refresh = false
      }).catch(() => {
        vm.loading_get_universities = false
        vm.loading_get_universities_refresh = false
      })
    },
    selectUniversity(id) {
      this.data.university_id = id;
      this.data.username = '';
      this.data.password = '';

      this.$refs.university_form.scrollIntoView(true);
      this.$refs.username.focus();
    },
    addUniversity() {
      const vm = this;
      vm.loading_connect = true;

      this.$axios.post(UNIVERSITY.ADD_TO_ME, this.data).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          if (typeof vm.afterSave === 'function') {
            vm.afterSave();
          } else {
            vm.getMyUniversities();
            let username = _.clone(vm.data.username)
            vm.data = {
              university_id: '',
              username: '',
              password: ''
            };

            if (!vm.isEmpty(username)) {
              vm.$router.push('/panel/university');
            } else {
              vm.$router.push('/panel');
            }
          }

          this.$buefy.toast.open({
            message: data.applicationSystem.message,
            type: 'is-success'
          });
        } else {
          this.$buefy.toast.open({
            message: data.applicationSystem.message,
            type: 'is-danger'
          });
        }

        vm.loading_connect = false;
      }).catch(() => {
        vm.loading_connect = false;
        vm.data.password = '';
      })
    },
  }
}
</script>

<style scoped>
.is-divider-vertical[data-content]::after, .is-divider[data-content]::after {
  background: #f5f6f7;
}
.card-table {
  overflow-y: auto;
  max-height: 50vh;
}
</style>
